import { IoIosArrowForward } from "react-icons/io";
import style from "./RightArrow.module.css";

const RightArrow = ({ onClick }) => {
  return (
    <button
      onClick={() => onClick()}
      className={[style.btn, style.btnRight].join(" ")}
    >
      <IoIosArrowForward />
    </button>
  );
};

export default RightArrow;
